import { Card, CardBody } from '@heroui/react';
import React from 'react';

import { PageHeader } from '../../../../../components/PageHeader';
import { LoadingTable } from '../../../../../components/Table';

export const LoadingState: React.FC = () => {
  return (
    <div className="p-6 min-h-screen bg-background">
      <PageHeader title="Loading..." description="Loading supplier details" />
      <Card className="mt-6">
        <CardBody className="p-6">
          <LoadingTable
            columns={[{ label: 'Details', className: 'w-full' }]}
            rowCount={1}
            ariaLabel="Loading supplier details"
            loadingMessage="Loading supplier details..."
          />
        </CardBody>
      </Card>
    </div>
  );
};
